var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`draft-saved-hint ${_vm.determineIfHidden}`},[_c('p',{class:`${_vm.formatStatusClass}`},[_vm._v(_vm._s(_vm.formatStatus))])])
}
var staticRenderFns = []

export { render, staticRenderFns }